module.exports = __webpack_public_path__ + "img/poseCVCMid.b8bce698.jpg";